module.exports = __webpack_public_path__ + "img/2.a405ce70.png";